export default __webpack_public_path__ + "static/media/not-found-mobile.ae49547d.svg";